var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrepaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 24,
    viewBox: "0 0 37 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7697 1.05127H3.23007C1.93263 1.05127 0.880859 2.10742 0.880859 3.41024V19.9231C0.880859 21.2259 1.93263 22.282 3.23007 22.282H33.7697C35.0672 22.282 36.119 21.2259 36.119 19.9231V3.41024C36.119 2.10742 35.0672 1.05127 33.7697 1.05127Z",
    stroke: "#4F4E4E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 18.0947V11.6665M18.4999 11.6665L13.9307 5.23828M18.4999 11.6665L23.0691 5.23828",
    stroke: "#D93348",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8467 16.2549H22.1527",
    stroke: "#D93348",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8467 12.5864H22.1527",
    stroke: "#D93348",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.880859 3.41024V8.12819C2.74848 8.12819 4.54562 7.38512 5.86118 6.05229C7.17673 4.71947 7.92848 2.92665 7.92848 1.05127H3.23007C1.938 1.05127 0.880859 2.10101 0.880859 3.41024Z",
    fill: "#D93348",
    stroke: "#4F4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1189 3.41024V8.12819C34.2513 8.12819 32.4541 7.38512 31.1386 6.05229C29.823 4.71947 29.0713 2.92665 29.0713 1.05127H33.7697C35.0618 1.05127 36.1189 2.10101 36.1189 3.41024Z",
    fill: "#D93348",
    stroke: "#4F4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.880859 19.923V15.2051C2.74848 15.2051 4.54562 15.9482 5.86118 17.281C7.17673 18.6138 7.92848 20.4066 7.92848 22.282H3.23007C1.938 22.282 0.880859 21.2323 0.880859 19.923Z",
    fill: "#D93348",
    stroke: "#4F4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1189 19.923V15.2051C34.2513 15.2051 32.4541 15.9482 31.1386 17.281C29.823 18.6138 29.0713 20.4066 29.0713 22.282H33.7697C35.0618 22.282 36.1189 21.2323 36.1189 19.923Z",
    fill: "#D93348",
    stroke: "#4F4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepaid);
export default __webpack_public_path__ + "static/media/prepaid.78967dbfb34c58713be1c5dc93d478d5.svg";
export { ForwardRef as ReactComponent };